// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.projects_container__E\\+oYs {
  display: grid;
  grid-template-columns: 100%;
  gap: 1rem;
  width: 100%;
  padding: 1rem;
  margin: 0 0 4rem;
}

.projects_responsiveSection__FmLd3 {
  position: relative;
  width: 100%;
}

.projects_responsiveImage__lA9PD {
  position: relative;
  width: 100%;
  height: 250px;
}

.projects_image__wAMMx {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.projects_overlay__bG2am {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;

  & h2 {
    cursor: pointer;
    text-decoration: underline;
    color: var(--text-color);
    font-family: Inter;
    font-size: 1.6rem;
    font-weight: 700;
  }

  & p {
    width: 85%;
    margin: 0;
    color: var(--text-color);
    font-family: Inter;
    font-size: 1rem;
    font-weight: 400;
    line-height: 22px;
  }
}

.projects_textContent__UGehr {
  color: var(--text-color);
  padding: 1rem;
}

/* --------media-queries----------- */

@media (min-width: 640px) {
  .projects_responsiveImage__lA9PD {
    height: 300px;
  }

  .projects_title__4iOj- {
    font-size: 2rem;
  }

  .projects_description__f90q6 {
    font-size: 1.25rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/AllProjects/projects.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,qBAAqB;EACrB,yBAAyB;;EAEzB;IACE,eAAe;IACf,0BAA0B;IAC1B,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,SAAS;IACT,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE,wBAAwB;EACxB,aAAa;AACf;;AAEA,qCAAqC;;AAErC;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".container {\n  display: grid;\n  grid-template-columns: 100%;\n  gap: 1rem;\n  width: 100%;\n  padding: 1rem;\n  margin: 0 0 4rem;\n}\n\n.responsiveSection {\n  position: relative;\n  width: 100%;\n}\n\n.responsiveImage {\n  position: relative;\n  width: 100%;\n  height: 250px;\n}\n\n.image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.overlay {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n\n  & h2 {\n    cursor: pointer;\n    text-decoration: underline;\n    color: var(--text-color);\n    font-family: Inter;\n    font-size: 1.6rem;\n    font-weight: 700;\n  }\n\n  & p {\n    width: 85%;\n    margin: 0;\n    color: var(--text-color);\n    font-family: Inter;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 22px;\n  }\n}\n\n.textContent {\n  color: var(--text-color);\n  padding: 1rem;\n}\n\n/* --------media-queries----------- */\n\n@media (min-width: 640px) {\n  .responsiveImage {\n    height: 300px;\n  }\n\n  .title {\n    font-size: 2rem;\n  }\n\n  .description {\n    font-size: 1.25rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `projects_container__E+oYs`,
	"responsiveSection": `projects_responsiveSection__FmLd3`,
	"responsiveImage": `projects_responsiveImage__lA9PD`,
	"image": `projects_image__wAMMx`,
	"overlay": `projects_overlay__bG2am`,
	"textContent": `projects_textContent__UGehr`,
	"title": `projects_title__4iOj-`,
	"description": `projects_description__f90q6`
};
export default ___CSS_LOADER_EXPORT___;
